/**
 * Newsletter Popup
 * Follows legal-age-popup.js pattern.
 */
(function () {
  'use strict';

  var DISMISSED = 'nl_popup_dismissed';
  var isEditor = window.Shopify && window.Shopify.designMode;

  if (!isEditor && localStorage.getItem(DISMISSED)) return;

  var el = document.getElementById('newsletter-popup');
  if (!el) return;

  var delay = parseInt(el.dataset.delay, 10) || 4000;

  function open() {
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    localStorage.setItem(DISMISSED, '1');
  }

  setTimeout(open, delay);

  // Close button
  var closeBtn = el.querySelector('[data-nl-close]');
  if (closeBtn) closeBtn.addEventListener('click', close);

  // Close on overlay click
  el.addEventListener('click', function (e) {
    if (e.target === el) close();
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && el.classList.contains('is-open')) close();
  });

  // On form submit: just dismiss the popup so it doesn't reappear.
  // The form posts to a hidden iframe — no fake success state.
  var form = el.querySelector('.mailup-newsletter-form');
  if (form) {
    form.addEventListener('submit', function () {
      localStorage.setItem(DISMISSED, '1');
      setTimeout(close, 400);
    });
  }
})();
